import React, { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import menuStyles from './styles';
import { SvgIcon } from '@material-ui/core';

type Props = {
  icon: any;
  title: string;
  shortcut: string;
  onTrigger: () => void; 
  disabled?: boolean;
  open?: boolean;
}; 

const ActionableMenuItem = (props: Props) => {
  const classes = menuStyles();

  const {
    icon,
    title,
    shortcut,
    onTrigger,
    disabled,
    open,
  } = props;

  const trigger = useCallback(() => {
    !disabled && onTrigger();
  }, [disabled, onTrigger]);

  useHotkeys(shortcut, trigger, { keydown: true, keyup: false }, [trigger]);

  return open ? (
    <div className={disabled ? classes.disabledItem : classes.menuItem} onMouseUp={trigger}>
      <div className={classes.preTitle}><SvgIcon className={classes.icon}>{ icon }</SvgIcon></div>
      <div className={classes.title}>{ title }</div>
      <div className={classes.shortcutText}>{ shortcut }</div>
    </div>
  ) : <></>;
};

export default ActionableMenuItem;